import { FragmentListItemDto } from '@app/modules/fragments/fragment.types';
import { Box } from '@mui/material';
import { FragmentCardDurationPill } from '../base/FragmentCardDurationPill';
import { FragmentCardListBase } from '../base/FragmentCardListBase';
import { FragmentCardMediaBottomRightItem } from '../base/FragmentCardMediaBottomRightItem';
import { AudioFragmentWaveform } from './AudioFragmentWaveform';

/**
 * List layout for an audio fragment card: waveform (with duration pill on media),
 * title, time/duration, creator and created at, statuses. Used when viewMode is 'list'.
 */
export function AudioFragmentCardList({ fragment }: { fragment: FragmentListItemDto }) {
  return (
    <FragmentCardListBase
      fragment={fragment}
      media={
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            height: '100%',
            minHeight: 100,
            bgcolor: (theme) =>
              theme.palette.mode === 'dark' ? theme.palette.grey[800] : theme.palette.grey[100],
          }}
        >
          <AudioFragmentWaveform fragment={fragment} />
          <FragmentCardMediaBottomRightItem>
            <FragmentCardDurationPill fragment={fragment} />
          </FragmentCardMediaBottomRightItem>
        </Box>
      }
    />
  );
}
